/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["*[_ngcontent-%COMP%]{box-sizing:border-box;outline:0}#wrap[_ngcontent-%COMP%]   #main[_ngcontent-%COMP%]{font-size:14px!important;height:100%!important;padding:0 15px;top:0!important}#wrap[_ngcontent-%COMP%]   #main[_ngcontent-%COMP%]   #submain[_ngcontent-%COMP%] > .content[_ngcontent-%COMP%]{padding-bottom:15px}"];
export { styles as styles };
